import { combineReducers } from 'redux'
import { routerReducer, RouterState } from 'react-router-redux'
import { Reducer, StateType } from 'typesafe-actions'
import { createSiteConfigReducer, SiteConfigState } from './SiteConfig'
import { exceptionReducer, ExceptionState } from './Exception'
import { reportReducer, ReportState } from './Report'
import { marketReducer, MarketState } from './Market'
import { IMessageService } from '../common/IMessageService'
import { AnyAction } from 'typescript-fsa'

export const createRootReducer = (messageService: IMessageService) => combineReducers({
  siteConfig: createSiteConfigReducer(messageService),
  exception: exceptionReducer,
  report: reportReducer,
  market: marketReducer,
  routing: routerReducer,
})

export type RootState = StateType<Reducer<{
  siteConfig: SiteConfigState;
  exception: ExceptionState;
  report: ReportState;
  market: MarketState;
  routing: RouterState;
}, AnyAction>>
